import {createSelector} from 'reselect'

export const getMailSettingsState = state => state.mailSettings

export const areMailSettingsSpecified = createSelector(
    getMailSettingsState,
    (mailSettings) => mailSettings.mailSettingsSpecified
)



// WEBPACK FOOTER //
// ./web/js/administration/mailSettings/selectors.js